import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store/index';
import 'element-ui/packages/theme-chalk/lib/index.css';
import { messagePlugin } from '@/util/message';

import './assets/theme/index.less';
import echarts from 'echarts';


Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;

import publishObjectPath from '@/util/configRegistry';

import * as ElementUI from 'element-ui';
// 三维静态资源
(window as any).EGIS_BASE_URL = './deps/egis/static/';
Vue.use(ElementUI , { zIndex: 999999 });

Vue.use(messagePlugin, 'messageBus');

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

